<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :md='8' :sm='12'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'followUserName')">
              <!--              <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY.COLLECTION + 'followUserName'))" v-model="queryParam.followUserName"></a-input>-->
              <a-select
                style='width: 100%'
                v-model='queryParam.followUserName'
                optionFilterProp="children"
                showSearch
                allowClear
              >
                <a-select-option v-for='item in CollectorNameList' :key='item.value' :value='item.value'>
                  {{ item.key }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='8' :sm='12'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'createTime')">
              <a-range-picker
                v-model='queryParam.endTime'
                format='YYYY-MM-DD'
                style='width: 100%;' />
            </a-form-item>
          </a-col>

          <a-col :md='8' :sm='12'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'settleTime')">
              <a-range-picker
                v-model='queryParam.settleTime'
                format='YYYY-MM-DD'
                style='width: 100%;' />
            </a-form-item>
          </a-col>


          <template v-if='toggleSearchStatus'>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY.COLLECTION + 'collectionTaskStatus')">
                <dict-select
                  style='width: 100%'
                  v-model='queryParam.collectionTaskStatus'
                  :dict-code='DICT_CODE.COLLECTION_TASK_STATUS'
                  :begin="[{ value: '', label: '全部', labelEn: 'All' }]"
                  :placeholder="$t('select')"
                />
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY.ORDER + 'orderNo')">
                <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY.ORDER + 'orderNo'))"
                         v-model='queryParam.orderNo'></a-input>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY.CUSTOMER + 'custName')">
                <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY.CUSTOMER + 'custName'))"
                         v-model='queryParam.aadhaarName'></a-input>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY.CUSTOMER + 'mobile')">
                <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY.CUSTOMER + 'mobile'))"
                         v-model='queryParam.mobileNo'></a-input>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY.ORDER + 'overdueDays')">
                <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY.ORDER + 'overdueDays'))"
                         v-model='queryParam.overdueDaysStart'></a-input>
              </a-form-item>
            </a-col>

            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY.COLLECTION + 'repaymentIntention')">
                <dict-select
                  style='width: 100%'
                  v-model='queryParam.repaymentIntention'
                  :dict-code='DICT_CODE.REAPYMENT_INTENTION'
                  :begin="[{ value: '', label: '全部', labelEn: 'All' }]"
                  :placeholder="$t('select')"
                />
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY.COLLECTION + 'followResult')">
                <dict-select
                  style='width: 100%'
                  v-model='queryParam.followResult'
                  :dict-code='DICT_CODE.FOLLOW_RESULT'
                  :begin="[{ value: '', label: '全部', labelEn: 'All' }]"
                  :placeholder="$t('select')"
                />
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY.COLLECTION + 'isFollow')">
                <a-select style='width: 100%' default-value=""  v-model="queryParam.isFollow">
                  <a-select-option value=''>
                    全部
                  </a-select-option>
                  <a-select-option value='1'>
                    已跟进
                  </a-select-option>
                  <a-select-option value='0'>
                    未跟进
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t(I18N_KEY.ORDER + 'orderId')">
                <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY.ORDER + 'orderId'))"
                         v-model='queryParam.orderId'></a-input>
              </a-form-item>
            </a-col>
            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t('platformCollection.department')">
                <a-select
                  style='width: 100%'
                  v-model='queryParam.departmentId'
                  @change='onChangeOne'
                  allowClear
                >
                  <a-select-option v-for='item in departmentList' :key='item.id'>
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t('platformCollection.grouping')">
                <a-select
                  style='width: 100%'
                  v-model='queryParam.groupId'
                  allowClear
                >
                  <a-select-option v-for='item in searchGroupList' :key='item.id'>
                    {{ item.groupName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md='8' :sm='12'>
              <a-form-item :label="$t('platformCollection.collection_stage')">
                <a-select
                  style='width: 100%'
                  allowClear
                  default-value=''
                  v-model='queryParam.normalConfigId'
                >
                  <a-select-option v-for='item in normalConfigList' :key='item.id' >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md='8' :sm='12'>
              <a-form-item :label="'盘号'">
                <a-select
                  style='width: 100%'
                  allowClear
                  v-model='queryParam.appssid'
                >
                  <a-select-option v-for='item in appInfoList' :key='item.appssid'>
                    {{ item.appName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md='8' :sm='12'>
              <a-form-item :label="'用户类型'">
                <a-select allowClear default-value='' style='width: 100%' v-model='queryParam.loanCountFlag'>
                  <a-select-option value='00'>
                    新户
                  </a-select-option>
                  <a-select-option value='01'>
                    老户
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md='8' :sm='12'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'endDate')">
              <a-range-picker
                v-model='queryParam.endDate'
                format='YYYY-MM-DD'
                style='width: 100%;' />
            </a-form-item>
          </a-col>

          </template>
          <a-col :md='8' :sm='12'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                }}</a-button>
                <a-button type='primary' @click='downLoadData' icon='download'
                        style='margin-left: 8px'>{{ $t('exportFile') }}</a-button>
               <a @click='handleToggleSearch' style='margin-left: 8px'>
                     {{ $t(toggleSearchStatus ? 'hide' : 'show') }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                  </a>
            </span>
          </a-col>
        </a-row>
      </a-form>


      <a-button style='margin-bottom: 20px;' type='primary' @click='openBatchDialog' :disabled='!selectedList.length'
                icon='plus'>{{ $t(I18N_KEY.COLLECTION + 'batchReplacementFollowStaff') }}
      </a-button>

      <a-table
        ref='table'
        size='middle'
        rowKey='taskId'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        :rowSelection='{ onChange: selectRowsChange, selectedRowKeys }'
        bordered>
        <Dict slot='followResult' slot-scope='text' :dict-code='DICT_CODE.FOLLOW_RESULT' :value='text' />
        <Dict slot='repaymentIntention' slot-scope='text' :dict-code='DICT_CODE.REAPYMENT_INTENTION' :value='text' />
        <Dict slot='collectionTaskStatus' slot-scope='text' :dict-code='DICT_CODE.COLLECTION_TASK_STATUS'
              :value='text' />

        <span slot='action' slot-scope='text, record'>
          <!-- slot-scope="text, record" -->
            <a @click='handleDetail(record)'>{{ $t('view') }}</a>
              <a-divider type='vertical' />
            <a v-if="record.collectionTaskStatus == '0'||record.collectionTaskStatus == '1'"
               @click='handleUser(record)'>{{ $t(I18N_KEY.COLLECTION + 'transferOrder') }}</a>
        </span>
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
    </div>


    <v-modal
      v-model='visible'
      :title="$t('order.collectionDetail')">
      <div style='padding: 20px;'>
        <collection-detail
          v-if='visible'
          :orderId='orderId'
          :custInfoId='custInfoId'
          :taskId='taskId'
          :auditDrawer='false'
          @close='visible = false;' />
      </div>
    </v-modal>
    <a-modal
      v-model='visibleT'
      :title="$t(I18N_KEY.COLLECTION + 'transferOrder')"
      @ok='handleOk'
      :confirmLoading='confirmLoading'
      @cancel='handleCancel'
    >
      <a-radio-group @change='onChange' v-model='selectUser'>
        <a-radio v-for='(item) in ExamineUser' :key='item.userId' :style='radioStyle' :value='item.userId'>
          {{ item.userName }}
        </a-radio>
      </a-radio-group>
    </a-modal>
    <a-modal
      v-model='batchVisible'
      :title="$t(I18N_KEY.COLLECTION + 'batchReplacementFollowStaff')"
      :confirmLoading='confirmLoading'
      :width='700'
      @ok='submitBatch'
      @cancel='closeBatchDialog'
    >
      <div>
        <div>
          <p class='description d_title'>{{ $t('platformCollection.instructions_for_filling_in') }}</p>
          <p class='description d_text'>{{ $t('platformCollection.instructions_for_filling_in_1') }}</p>
          <p class='description d_text'>{{ $t('platformCollection.instructions_for_filling_in_2') }}</p>
        </div>
        <p class='description d_high_light'>{{ $t('platformCollection.total_order_quantity_checked')
          }}{{ selectedList.length }}</p>
        <p style='width: 30%'>
          <a-input :placeholder="$t('enter') + ' ' + $t('platformCollection.name_of_collector')"
                   v-model='queryParam.inName'></a-input>
        </p>
        <p style='width: 30%'>
          <a-select style='width: 190px'
                    v-model='queryParam.groupIdIn'
          >
            <a-select-option v-for='item in groupList' :key='item.id'>
              {{ item.groupName }}
            </a-select-option>
          </a-select>
        </p>

        <p style='width: 30%'>
          <a-button type='primary' @click='searchBatch' icon='search'>{{ $t('search') }}</a-button>
        </p>
        <a-table
          ref='table'
          rowKey='id'
          size='middle'
          :columns='batchColumns'
          :dataSource='batchList'
          :pagination='false'
          :loading='batchLoading'
          bordered>
            <span slot='action' slot-scope='text, record'>
                <a-input v-model='record.taskNum' />
            </span>
        </a-table>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import {
  getAllCollectionTask,
  getCollectionUser,
  modCollectionTaskUser,
  getSysGroup
} from '@/webpublicapi/platformCollection'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'
import vModal from '../modules/Modal'
import CollectionDetail from './CollectionDetail'
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { getAllNormalConfig } from '@/webpublicapi/normalConfig'
import { getApplist } from '@/webpublicapi/order'
import { getCollectorName } from '@/webpublicapi/collection'
import { getCollectionListDepartment } from '@/webpublicapi/group'
import { exportFileByPost } from '@/api/exportFile'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.',
  REPAYREPORT: 'repayReport'
}

export default {
  name: 'AllApprovalTask',
  components: {
    Dict,
    DictSelect,
    vModal,
    CollectionDetail
  },
  data() {
    return {
      CollectorNameList: [],
      I18N_KEY,
      toggleSearchStatus: false,
      confirmLoading: false,
      visible: false,
      visibleT: false,
      orderId: undefined,
      custInfoId: undefined,
      taskId: undefined,
      batchVisible: false,
      batchLoading: false,
      groupId: undefined,
      departmentId: undefined,
      selectedRowKeys: [],
      selectedList: [],
      groupList: [],
      searchGroupList: [],
      departmentList: [],
      normalConfigList: [],
      appInfoList: [],
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      // 查询条件
      queryParam: {
        'orderNo': '',
        'aadhaarName': '',
        'mobileNo': '',
        collectionTaskStatus: '',
        followResult: '',
        repaymentIntention: '',
        endDate: [],
        endTime: [moment(),moment()],
        settleTime: [],
        inName: '',
        loanCountFlag: '',
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      },
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      selectUser: '',
      ExamineUser: [],
      isFollow: ''
    }
  },
  computed: {

    ...mapGetters('platformCollection', ['listUserWithNum']),
    batchList() {
      return this.listUserWithNum || []
    },
    columns() {
      return [
        {
          title: this.$t('order.orderId'),
          align: 'left',
          dataIndex: 'orderId'
        },
        {
          title: this.$t('repayReport.appSsid'),
          align: 'left',
          dataIndex: 'appSsid'
        },
        {
          title: this.$t('order.orderNo'),
          align: 'left',
          dataIndex: 'orderNo'
        },
        {
          title: this.$t('customer.custName'),
          align: 'left',
          dataIndex: 'aadhaarName'
        },
        {
          title: this.$t('order.overdueDays'),
          align: 'left',
          dataIndex: 'overdueDay',
          customRender: (text) => {
            // text 就是当前行的 overdueDay 值
            return text === 0 || text === '0' ? '' : text;
          }
        },
        {
          title: this.$t('collection.createTime'),
          align: 'left',
          dataIndex: 'createTime'
        },
        {
          title: this.$t('collection.followNum'),
          align: 'left',
          dataIndex: 'followNum'
        },
        {
          title: this.$t('collection.followTime'),
          align: 'left',
          dataIndex: 'followTime'
        },
        {
          title: this.$t('collection.followUserName'),
          align: 'left',
          dataIndex: 'followUserName'
        },
        {
          title: this.$t('collection.followResult'),
          align: 'left',
          dataIndex: 'followResult',
          scopedSlots: { customRender: 'followResult' }
        },
        {
          title: this.$t('collection.repaymentIntention'),
          align: 'left',
          dataIndex: 'repaymentIntention',
          scopedSlots: { customRender: 'repaymentIntention' }
        },
        // {
        //   title: '备注',
        //   align: 'left',
        //   dataIndex: 'callInfo',
        // },
        {
          title: this.$t('collection.collectionTaskStatus'),
          align: 'left',
          dataIndex: 'collectionTaskStatus',
          scopedSlots: { customRender: 'collectionTaskStatus' }
        },
        {
          title: this.$t('platformCollection.collection_stage'),
          align: 'left',
          dataIndex: 'normalConfigId'
        },
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
    batchColumns() {
      return [
        {
          title: this.$t('name'),
          align: 'left',
          dataIndex: 'userName'
        },
        {
          title: this.$t('order.hasColOrder'),
          align: 'left',
          dataIndex: 'undoNum'
        },
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    this.getDict()
    // this.loadData(1);

    getSysGroup().then(res => {
      this.groupList = res.data || []
      this.searchGroupList = res.data || []
    })
    getCollectionListDepartment().then(res => {
      this.departmentList = res.data || []
    })
    getAllNormalConfig().then(res => {
      this.normalConfigList = res.data || []
    })
    getApplist().then(res => {
      this.appInfoList = res.data || []
    })
    //催收员名称
    getCollectorName().then(res => {
      console.log('res-->', res.data)
      let keys = Object.keys(res.data)
      for (const key of keys) {
        this.CollectorNameList.push({
          key: key,// s1test1
          value: res.data[key]
        })
      }
      console.log('催收员res--->this.CollectorNameList ', this.CollectorNameList)
    })
  },
  methods: {
    // searchFn(val){
    //
    //   let arr = []
    //   for(let item of this.normalConfigList){
    //     if( item.name.includes(val)){
    //       arr.push(item)
    //     }
    //   }
    //
    //   this.normalConfigList = arr
    //   console.log("val",this.normalConfigList)
    // },
    ...mapActions('platformCollection', ['getListUserWithNum', 'batchChangeUser']),
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    CollectorNameListChange(e) {
      console.log('下拉框发生变化啦！', e)
      // this.followUserName = e
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // 清空选中项
      this.selectedList = []
      this.selectedRowKeys = []
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      getAllCollectionTask(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.rows
          this.dataSource.forEach(item => {
            item.followResult != null ? String(item.followResult) : '';
            this.normalConfigList.forEach(config => {
              if (item.normalConfigId == config.id) {
                item.normalConfigId = config.name
              }
            })
            this.appInfoList.forEach(appInfo => {
              if (item.appSsid == appInfo.appssid) {
                item.appSsid = appInfo.appName
              }
            })
          })
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    async downLoadData() {
      var params = this.getQueryParams()// 查询条件
      this.loading = true
      try {
        const result = await exportFileByPost(
          `/api/web/webpublic/platform/collectionTask/allTaskExcel`,
          params,
          "催收任务管理表.xlsx"
        );
        if (result instanceof Error) {
          this.$message.error(result.message);
        }
      } catch(error) {
          this.$message.error(error.message);
      } finally{
        this.loading = false
      }
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    selectRowsChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.originSelectedList = selectedRows
      this.selectedList = _.cloneDeep(selectedRows)
    },
    openBatchDialog() {
      this.batchVisible = true
      this.batchLoading = true
      this.selectedList.length && this.getListUserWithNum().finally(res => {
        this.batchLoading = false
      })
    },
    closeBatchDialog() {
      this.batchVisible = false
      this.selectedList = _.cloneDeep(this.originSelectedList || [])
    },
    submitBatch() {
      const taskIds = this.selectedList.map(t => t.taskId)
      const userTask = this.batchList.map(t => ({ userId: t.userId, taskNum: t.taskNum ? +t.taskNum : 0 }))
      const totalNum = userTask.map(t => t.taskNum).reduce((total, num) => (total += num), 0)
      console.log(userTask, totalNum)
      if (!userTask.length) {
        return this.closeBatchDialog()
      }
      if (isNaN(totalNum)) {
        return this.$message.error(this.$t('please_enter_a_positive_integer'))
      }
      if (totalNum > this.selectedList.length) {
        return this.$message.error(this.$t('platformCollection.cannot_be_greater_than_the_total_quantity_of_the_checked_order'))
      }
      this.closeBatchDialog()
      this.loading = true
      this.batchChangeUser({ taskIds, userTask }).then(res => {
        this.loadData()
        this.$message.success(this.$t('success'))
      }).finally(res => {
        this.loading = false
      })
    },
    getQueryParams() {
      const { endTime } = this.queryParam
      const { settleTime } = this.queryParam
      const { endDate } = this.queryParam
      const data = {
        ...this.queryParam,
        // endDateStart: this.transformTime(endTime) === null ? undefined : this.transformTime(endTime),
        // endDateEnd: this.transformTime(endTime) === null ? undefined : this.transformTime(endTime)
        endDateStart: (endTime && endTime.length) ? this.transformTime(endTime[0]) : undefined,
        endDateEnd: (endTime && endTime.length) ? this.transformTime(endTime[1]) : undefined,
        dueDateStart: (endDate && endDate.length) ? this.transformTime(endDate[0]) : undefined,
        dueDateEnd: (endDate && endDate.length) ? this.transformTime(endDate[1]) : undefined,
        settleDateStart: (settleTime && settleTime.length) ? this.transformTime(settleTime[0]) : undefined,
        settleDateEnd: (settleTime && settleTime.length) ? this.transformTime(settleTime[1]) : undefined,
      }
      delete data.endTime
      delete data.settleTime
      delete data.endDate
      var param = Object.assign({}, data)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize
      return filterObj(param)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.orderNo = ''
      that.queryParam.aadhaarName = ''
      that.queryParam.mobileNo = ''
      that.queryParam.endTime = [moment(),moment()]
      that.queryParam.settleTime =[]
      that.queryParam.endDate =[]
      that.queryParam.followUserName = ''
      that.queryParam.collectionTaskStatus = ''
      that.queryParam.repaymentIntention = ''
      that.queryParam.overdueDaysStart = ''
      that.queryParam.normalConfigId = ''
      that.queryParam.orderId = ''
      that.queryParam.followResult = ''
      that.queryParam.appssid = ''
      that.queryParam.loanCountFlag = ''
      that.loadData(this.form.pageNum)
    },
    changeModal(visible) {
      this.visible = visible
    },
    handleDetail(row) {
      this.orderId = row.orderId
      this.custInfoId = row.custInfoId
      this.taskId = row.taskId
      this.changeModal(true)
    },
    handleUser(row) {
      this.selectUser = ''
      this.taskId = row.taskId
      this.confirmLoading = true
      if (this.ExamineUser.length == 0) {
        getCollectionUser().then((res) => {
          if (res.code === 1000) {
            this.ExamineUser = res.data
          } else {
            this.ExamineUser = []
            this.$message.error(res.msg)
          }
          this.confirmLoading = false
        }).catch(e => {
          this.confirmLoading = false
          this.$message.error(e.message)
        })
      } else {
        this.confirmLoading = false
      }
      this.visibleT = true
    },
    onChange(e) {
      this.selectUser = e.target.value
    },
    handleOk(e) {
      if (this.selectUser != '') {
        this.confirmLoading = true
        modCollectionTaskUser({ userId: this.selectUser, taskId: this.taskId }).then((res) => {
          if (res.code === 1000) {
            this.visibleT = false
            this.confirmLoading = false
            this.loadData()
          } else {
            this.confirmLoading = false
            this.$message.error(res.msg)
          }
        }).catch(e => {
          this.confirmLoading = false
          this.$message.error(e.message)
        })
      } else {
        this.$message.error(this.$t('platformCollection.please_select_a_credit_examiner'))
      }
    },
    handleCancel(e) {
      this.visibleT = false
    },
    searchBatch() {
      this.batchLoading = true
      this.getListUserWithNum({
        userName: this.queryParam.inName,
        groupIdIn: this.queryParam.groupIdIn
      }).finally(res => {
        this.batchLoading = false
      })
    },
    onChangeOne(value) {
      console.log(value)
      getSysGroup({ 'departmentId': value }).then(res => {
        this.searchGroupList = res.data || []
        this.queryParam.groupId = ''
      })
    },
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";

.description {
  line-height: 1.4;

  &.d_text {
    text-indent: 1em;
  }

  &.d_high_light {
    color: #fd9a38;
  }
}
</style>
